import SuiBox from "components/SuiBox";

import logo from "assets/images/upstyled/logo.png";

const UpStyledLogo = ({ ...rest }) => {
  return <SuiBox component="img" {...rest} src={logo} />;
};

export default UpStyledLogo;
